export default __webpack_public_path__ + "static/media/postItOnHold.aee2b25b.png";